import { render, staticRenderFns } from "./RiderDebitTransactions.vue?vue&type=template&id=67a4c85b"
import script from "./RiderDebitTransactions.vue?vue&type=script&lang=js"
export * from "./RiderDebitTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports